module.exports = __webpack_public_path__ + "static/media/0353_Small.01b70f84.jpg";